import { hamburger } from "../components/hamburger/hamburger";
import { accordion } from "../components/accordion/accordion";
import { stickyHeader } from "../components/sticky-header/sticky-header";
//import { scrollR } from "../compontents/scroll-reveal/scroll-reveal";
//import { isotopeGallery } from "../components/isotope-gallery/isotope-gallery";
//import { slider } from "../components/gallery-slider/gallery-slider";
import { leistungenMenu } from "../components/leistungen-menu/leistungen-menu";
import {
  categoryPostsSlider,
  imageGallerySlider,
} from "../components/image-slider/image-slider";
import { heroSlider } from "../components/image-slider/image-slider";
import { lightbox } from "../components/simple-lightbox/simple-lightbox";
import { popup } from "../components/popup/popup";
import { ajaxSearch } from "../components/ajaxSearch/ajaxSearch";
import {eventform} from "../components/eventform/eventform";


document.addEventListener("DOMContentLoaded", function () {
  hamburger();
  stickyHeader();
  accordion();
  //isotopeGallery();
  //slider();
  //scrollR();
  imageGallerySlider();
  categoryPostsSlider();
  leistungenMenu();
  lightbox();

  //heroSlider();
  //popup();
  ajaxSearch();
  eventform();
});
